import React, { Component } from "react";
import moment from 'moment'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class ResponsesNotTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterNameOrPhone: undefined,
    };
  }

  render() {
    if (!this.props.showRecipients) {
      return (
        <div>
          <p>No data to show</p>
        </div>
      );
    }

    const filterNameOrPhone = this.state.filterNameOrPhone;
    var rows = filterNameOrPhone
      ? this.props.showRecipients.filter(
          (r) =>
          r.Recipient.name
              .toLowerCase()
              .includes(filterNameOrPhone.toLowerCase()) ||
              r.Recipient.phone.includes(filterNameOrPhone)
        )
      : this.props.showRecipients;

    return (
      <div>
        <input
          className="input mb-2"
          type="text"
          placeholder="Filter by name or phone #"
          onChange={(e) => this.setState({ filterNameOrPhone: e.target.value })}
        />

        <div className="">
          <table className="table is-striped is-fullwidth">
            <thead>
              <tr>
                <th className="">Name</th>
                <th className="">Phone #</th>
                <th className="has-text-centered">Sent</th>
                <th className="has-text-centered">Opened URL</th>
              </tr>
            </thead>

            <tbody>
              {rows.map((r) => {

                let showSent
                let showSentClass

                if (!r.sentStatus) {
                    showSent = <FontAwesomeIcon icon="spinner"></FontAwesomeIcon>
                    showSentClass = 'has-text-warning'
                } else if (r.sentStatus === 'SUCCESSFUL') {
                    showSent = <FontAwesomeIcon icon="check"></FontAwesomeIcon>
                    showSentClass = 'has-text-success has-text-centered'
                } else {
                    showSent = <FontAwesomeIcon icon="times"></FontAwesomeIcon>
                    showSentClass = 'has-text-danger has-text-centered'
                }

                let openedClass = ""
                let showOpened = ""
                
                if (r.sentStatus === 'SUCCESSFUL') {
                  if (!r.viewedAt) {
                    showOpened = "No"
                      openedClass = 'has-text-danger has-text-centered'
                  } else {
                    showOpened = moment(r.viewedAt).fromNow()
                      openedClass = 'has-text-warning has-text-centered'
                  }
                }
                
                return (
                <tr key={r.id}>
                  <th>{r ? r.Recipient.name : "Deleted Contact"}</th>
                  <th>{r ? r.Recipient.phone : ""}</th>
                  <th className={showSentClass}>{showSent}</th>
                  <th className={openedClass}>{showOpened}</th>
                </tr>
              )})}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
